import { userConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";
import { useState } from "react";

export function useIsAiAssistantAvailable(): boolean {
	const [isAvailable] = useState<boolean>(
		(): boolean => userConfiguration()
			.aiAssistant
			.isAiAssistantAvailable
	);

	return isAvailable;
}